export enum DriversConstants {
  GET_CONTRACTOR_DRIVERS_REQUEST = 'GET_CONTRACTOR_DRIVERS_REQUEST',
  GET_CONTRACTOR_DRIVERS_SUCCESS = 'GET_CONTRACTOR_DRIVERS_SUCCESS',
  GET_CONTRACTOR_DRIVERS_FAILURE = 'GET_CONTRACTOR_DRIVERS_FAILURE',
}
